<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "RoleComponent"
}
</script>

<style scoped>

</style>
